import { useQuery } from '@tanstack/react-query';
import { fetchCities } from "@/services/cities";
import { publicApi } from "@/lib/axios/instances";

export const useCitiesQuery = (
  config: Parameters<typeof publicApi.get>[1] = {},
  locale: string = 'ru'
) => {
  return useQuery({
    queryKey: ['cities', locale].filter(Boolean),
    queryFn: () => {
      return fetchCities(config)
    },
  });
};